// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-classes-EditClassPage-EditClassPage-module__mainBox--w0ofU {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}
.src-pages-classes-EditClassPage-EditClassPage-module__mainContent--I4dFS {
  flex: 1;
  overflow: auto;
}
/*# sourceMappingURL=EditClassPage.module.css.map */`, "",{"version":3,"sources":["webpack://./EditClassPage.module.less","webpack://./src/pages/classes/EditClassPage/EditClassPage.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;ACCF;ADCA;EACE,OAAA;EACA,cAAA;ACCF;AACA,mDAAmD","sourcesContent":[".mainBox {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 100%;\n}\n.mainContent {\n  flex: 1;\n  overflow: auto;\n}\n",".mainBox {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 100%;\n}\n.mainContent {\n  flex: 1;\n  overflow: auto;\n}\n/*# sourceMappingURL=EditClassPage.module.css.map */"],"sourceRoot":""}]);
// Exports
export var mainBox = `src-pages-classes-EditClassPage-EditClassPage-module__mainBox--w0ofU`;
export var mainContent = `src-pages-classes-EditClassPage-EditClassPage-module__mainContent--I4dFS`;
export default ___CSS_LOADER_EXPORT___;
